// packages/services/src/categoryService.ts
import { PaginatedResponse, Category } from '@cabukaka/types'
import { dataService } from './core/dataService';
import axios from 'axios';
import { getConfig } from '@cabukaka/config/index';
import { mapMongoDocs } from '@cabukaka/utils/index';

export const categoryService = {
    get baseService() {
        return dataService<Category>("categories");
    },

    getCategories: async (token?: string, page: number = 1, limit: number = 20): Promise<PaginatedResponse<Category>> => {
        return categoryService.baseService.getAll({ page, limit }, token);
    },

    getBoucherieCategories: async (token?: string): Promise<PaginatedResponse<Category>> => {
        const { apiUrl } = getConfig();
        console.log()
        try {
            const res = await axios.get<PaginatedResponse<Category>>(`${apiUrl}/categories/sector/slug/boucherie`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    getFeaturedCategories: async (limit: number = 8, token?: string): Promise<PaginatedResponse<Category>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Category>>(`${apiUrl}/categories/featured`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                params: { limit }
            });

            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
        
    },


    getCategoryBySlug: async (slug: string, token?: string): Promise<Category | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<Category>(`${apiUrl}/categories/slug/${slug}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    },

    getCategoriesBySectorSlug: async (slug: string, token?: string): Promise<PaginatedResponse<Category>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Category>>(`${apiUrl}/categories/sector/slug/${slug}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },
};